import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function OAuthDone({ inPopup = false }) {
    const navigate = useNavigate();
    // inPopup is passed explicitly by App.js when it detects the localStorage signal.
    // Fallback: check window.opener for cases where COOP didn't sever it.
    const isPopup = inPopup || !!(window.opener && window.opener !== window);

    useEffect(() => {
        if (isPopup) {
            const timer = setTimeout(() => window.close(), 1200);
            return () => clearTimeout(timer);
        } else {
            navigate('/settings', { replace: true, state: { default_tab: 'google-meta-integration' } });
        }
    }, [isPopup, navigate]);

    if (!isPopup) return null;

    return (
        <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            minHeight: '100vh', fontFamily: 'sans-serif', gap: 12, background: '#fff',
        }}>
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
                <circle cx="28" cy="28" r="28" fill="#16a34a" />
                <path d="M17 28l8 9 14-16" stroke="white" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <p style={{ fontSize: 17, color: '#101828', fontWeight: 700, margin: 0 }}>Connected successfully!</p>
            <p style={{ fontSize: 13, color: '#667085', margin: 0 }}>This window will close automatically…</p>
        </div>
    );
}

export default OAuthDone;
